import { useTranslation } from "react-i18next";

const UnauthorizedPage = () => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: 24 }}>
      <h2>{t("pages.unauthorized.heading")}</h2>
      <p>{t("pages.unauthorized.subMessage")}</p>
    </div>
  );
};

export default UnauthorizedPage;
